export default __webpack_public_path__ + "static/media/pic12_.ea82108b.jpg";